'use client'

/**
 * PreviewTable — the download card's CSV preview as a sortable table
 * (FRIDGE-450: "every table sorts"). A thin client wrapper because
 * SortableTable's column definitions carry functions, which cannot cross the
 * server→client boundary as props — the server card passes plain strings and
 * rows; the functions are built here. Same pattern as series-tables.
 *
 * Numeric-ness is inferred per column from the preview values themselves
 * (generic file columns — $, %, and comma formatting stripped for the test),
 * so number columns sort numerically and everything else lexically.
 */

import { SortableTable } from '@/app/data/_components/sortable-table'

type Cell = string | number

export function PreviewTable({
  caption,
  columns,
  rows,
}: {
  caption: string
  columns: string[]
  rows: Cell[][]
}) {
  const cols = columns.map((header, j) => {
    const numeric = rows.every((r) => {
      const cell = r[j]
      return cell !== undefined && cell !== '' && !Number.isNaN(Number(String(cell).replace(/[$,%]/g, '')))
    })
    return {
      key: `c${j}`,
      header,
      numeric,
      sortValue: (row: Cell[]) =>
        numeric ? Number(String(row[j]).replace(/[$,%]/g, '')) : String(row[j] ?? ''),
      render: (row: Cell[]) => row[j],
    }
  })
  return (
    <SortableTable
      caption={caption}
      columns={cols}
      rows={rows}
      rowKey={(row) => row.join('|')}
      minWidth={420}
      stickyFirstColumn={false}
    />
  )
}
